module.exports = __webpack_public_path__ + "static/media/bitcoin_nespresso_vending_machine_thumbnail.40ab742e.jpg";